import React, { useContext } from "react";
import { Badge, Text, LegacyCard as Card, Link, Thumbnail, InlineStack, Icon, Button, BlockStack, Box, Divider } from "@shopify/polaris";
import { NoteIcon } from "@shopify/polaris-icons";

import { PrivateContext } from "lib/context";
import constant from "lib/constant/constant";
import { baseHelper, imageHelper } from "lib/helpers";
import LineItemProperties from "app/orders/modules/generic/service/lineItemProperties";
import { StyledCard } from "app/orders/modules/operator/features/view/genericStyled";
import { useNavigate, useParams } from "react-router-dom";

const ReadyForService = (props) => {
  const { itemData, refundData } = props;
  const { cms } = useContext(PrivateContext);
  const { id } = useParams();
  const navigate = useNavigate();
  const amount = [];
  const vendorsSum = [];

  itemData
    .filter(
      (lineItem) =>
        lineItem.fulfillmentStatus !== constant.FULFILLED &&
        lineItem.fulfillmentType === constant.SERVICE &&
        lineItem.collectDetail
    )
    .forEach(({ vendor }) => {
      vendorsSum.push(vendor);
      return vendorsSum;
    });

  const vendorSet = new Set(vendorsSum);
  const setSize = vendorSet.size;
  const addVendorTxt =
    setSize === constant.value.ONE ? `${setSize} ${cms("label.vendor")}` : `${setSize} ${cms("label.vendors")}`;
  const lineDataItems = itemData.filter(
    (lineItem) =>
      lineItem.fulfillmentStatus !== constant.FULFILLED &&
      lineItem.fulfillmentType === constant.SERVICE &&
      lineItem.collectDetail
  ).length;

  const lineItems =
    itemData &&
    itemData.length &&
    itemData
      .filter(
        (item) =>
          [constant.UNFULFILLED, constant.PARTIAL].includes(item.fulfillmentStatus) &&
          item.fulfillmentType === constant.SERVICE &&
          item.collectDetail
      )
      .map((lineData, idx) => {
        const {
          actualQuantity = 0,
          collectDetail = {},
          fulfillableQuantity = 0,
          fulfillmentType = "",
          image = "",
          isProductDeleted,
          isRefund = false,
          moneyFormat: lineMoneyFormat,
          name,
          productId,
          properties,
          price,
          quantity = 0,
          sku,
          status,
          vendor,
        } = lineData || {};

        let { readyQuantity = 0 } = collectDetail || {};
        isRefund &&
          refundData &&
          refundData.forEach((refundItem) => {
            const { totalQuantity = 0 } = refundItem;
            readyQuantity -= totalQuantity;
          });
        const lineItemKey = `lineItem${idx}`;
        const lineImage =
          imageHelper.resize({ url: image, type: constant.imageTypes.THUMBNAIL }) || constant.NOIMAGESNAP;

        const moneyFormat = lineMoneyFormat || constant.symbol.DOLLAR;

        const newQuantity = parseInt(actualQuantity || quantity, 10) - parseInt(fulfillableQuantity, 10);
        const readyCollectQuantity = parseInt(readyQuantity, 10) - parseInt(newQuantity, 10);

        if (!readyCollectQuantity) {
          return null;
        }

        const totalPrice = price * readyCollectQuantity;

        amount.push(totalPrice);

        const lineItemName = <div className="productName">{name}</div>;
        const isServiceLineItem = baseHelper.isServiceLineItem(fulfillmentType, properties);
        const productURL = isServiceLineItem ? `/products/service/edit/${productId}` : `/products/edit/${productId}`;

        return (
          <div key={lineItemKey} className="fulfilled-Secn">
            <Box padding="400">
              <InlineStack wrap={false} align="space-between">
                <InlineStack wrap={false} gap="400">
                  <Thumbnail size="large" source={lineImage} alt={name} />
                  <BlockStack>
                    {(isProductDeleted && (lineItemName || "")) || (
                      <Link onClick={() => navigate(productURL)}>{name || ""}</Link>
                    )}


                    <Text as="span" color={constant.SUBDUED}>
                      {vendor ? `${cms("label.vendor")}: ${vendor}` : ""}
                    </Text>
                    <LineItemProperties
                      variation={constant.SUBDUED}
                      properties={properties}
                      isServiceLineItem={isServiceLineItem}
                    />

                    {isServiceLineItem ? (
                      ""
                    ) : (
                      <Text as="span" color={constant.SUBDUED}>
                        {cms("label.skuList")} {sku}
                        {" "}
                      </Text>
                    )}


                    <InlineStack gap="400" blockAlign="center">
                      <Badge status={baseHelper.getBadgeType(status)} className="text-capitalize">
                        {cms("label.readyService")}
                      </Badge>

                      <Button variant="plain" icon={NoteIcon} onClick={() => window.open(`/order-slip/${id}`)}>
                        <Text as="span">{`${cms("label.serviceSlip")}`}</Text>
                      </Button>
                    </InlineStack>
                  </BlockStack>
                </InlineStack>
                <InlineStack gap="400">
                  <Text as="span">{` ${cms("label.qty")}: ${readyCollectQuantity}`}</Text>
                  <Text as="span">
                    {moneyFormat}
                    {(totalPrice && totalPrice.toFixed(2)) || constant.value.ZERO}
                  </Text>
                </InlineStack>
              </InlineStack>
            </Box>
          </div>
        );
      });

  const stringToNumber = amount.map((item) => parseFloat(item));
  const totalAmount = stringToNumber.reduce((cur, acc) => cur + acc, constant.value.ZERO);

  const moneyFormat = (itemData && itemData.length && itemData[0].moneyFormat) || constant.symbol.DOLLAR;
  const totalFulfill = (
    <>
      <Divider />
      <Box padding="400">
        <InlineStack align="space-between" blockAlign="center">
          <Text as="span" fontWeight="semibold">
            {cms("label.total")}
          </Text>
          <InlineStack gap="400">
          <Text variant="bodySm" as="p">
            (
            {lineDataItems > 1
              ? `${lineDataItems}
                ${cms("label.items")} from ${addVendorTxt}`
              : `${lineDataItems}
                ${cms("label.item")} from ${addVendorTxt}`}
            )
          </Text>
          <Text as="span" fontWeight="semibold">{`${moneyFormat}${totalAmount.toFixed(2)}`}</Text>
          </InlineStack>
        </InlineStack>
      </Box>
    </>
  );

  return [lineItems, totalFulfill];
};

export default ReadyForService;
